// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../store-vue/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#viewerContainer[data-v-78311589]{max-height:300px;overflow:scroll}", ""]);
// Exports
module.exports = exports;
